export default {
  stateKey: 'superscript',
  order: 10,
  native: true,
}
